import DOMPurify from 'dompurify';

/**
 * Sanitizuje uživatelské HTML (formátovaný text z WYSIWYG editoru) před vykreslením přes
 * dangerouslySetInnerHTML. Používá bezpečný HTML profil – odstraní <script>, on* handlery,
 * javascript: URL, SVG/MathML apod. Zachová běžné formátování, base64 (data:) obrázky i data-* atributy.
 */
export const sanitizeUserHtml = (html?: string | null): string => {
    if (!html) {
        return '';
    }
    return DOMPurify.sanitize(html, {USE_PROFILES: {html: true}});
};

/**
 * Převede uživatelské HTML (formátovaný text) na čistý text bez značek – pro místa, kde formátování
 * vykreslit nelze (buňka tabulky, export). Bílé znaky (i ty z odřádkování v HTML) se sjednotí na mezery.
 */
export const htmlToPlainText = (html?: string | null): string => {
    if (!html) {
        return '';
    }
    // Sanitizace před parsováním – jinak by se do textu dostal i obsah <script>/<style>.
    const doc = new DOMParser().parseFromString(sanitizeUserHtml(html), 'text/html');
    return (doc.body.textContent ?? '').replace(/\s+/g, ' ').trim();
};

/**
 * Sanitizuje serverem vygenerované HTML detailu objektu. Důvěryhodná „kostra" šablony
 * (vč. legitimních javascript:window.postMessage(...) navigačních odkazů) zůstává nedotčená –
 * sanitizují se pouze uzly s uživatelským formátovaným textem (.formatted-text-value).
 */
export const sanitizeFeatureDetailHtml = (html?: string | null): string => {
    if (!html) {
        return '';
    }
    // Round-trip přes DOMParser děláme jen když je v HTML uživatelský formátovaný text.
    if (!html.includes('formatted-text-value')) {
        return html;
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    doc.querySelectorAll('.formatted-text-value').forEach((el: Element) => {
        el.innerHTML = sanitizeUserHtml(el.innerHTML);
    });
    return doc.body.innerHTML;
};
